import { ErrorSidebar, Loaded } from "@inrange/theme-components";
import * as Sentry from "@sentry/react";
import { useContext } from "react";
import getAdminAppDomain from "../utils/getAdminAppDomain";
import { UserContext } from "./UserContext";

const AdminChooseOrgPage = () => {
  const { user, logout } = useContext(UserContext);
  const doLogout = () => {
    if (logout) {
      if (import.meta.env.PROD) {
        Sentry.setUser(null);
      }
      logout();
    }
  };

  return (
    <ErrorSidebar onClickLogout={doLogout}>
      <Loaded>
        <div>Welcome {user?.email}. </div>
        <div>
          Please pick an organisation in the{" "}
          <a href={getAdminAppDomain()}>Admin Site</a>.
        </div>
      </Loaded>
    </ErrorSidebar>
  );
};

export default AdminChooseOrgPage;
